export enum FormType {
  Fixed = 1,
  Dynamic = 2,
  Submission = 3,
  Rejected = 4,
}
